import { defineStore } from 'pinia'
import { ref } from 'vue'
import apiClient from '@/services/api'

export const useConfigStore = defineStore('config', () => {
  const isCountdownMode = ref(false)
  const countdownEndDate = ref(null)
  const recaptchaSiteKey = ref(null)
  const isInitialized = ref(false)
  const freeShippingThreshold = ref(50) // Valore di fallback predefinito

  const fetchStoreStatus = async () => {
    try {
      const response = await apiClient.get('/Config/store-status')
      const newMode = response.data.isCountdownMode
      window.__IS_COUNTDOWN_MODE__ = newMode
      
      recaptchaSiteKey.value = response.data.recaptchaSiteKey
      
      // Caricamento dinamico di reCAPTCHA Enterprise se non presente
      if (recaptchaSiteKey.value && !document.querySelector(`script[src*="recaptcha/enterprise.js"]`)) {
        const script = document.createElement('script')
        script.src = `https://www.google.com/recaptcha/enterprise.js?render=${recaptchaSiteKey.value}`
        script.async = true
        script.defer = true
        document.head.appendChild(script)
      } else if (recaptchaSiteKey.value) {
        const existingScript = document.querySelector(`script[src*="recaptcha/enterprise.js"]`)
        if (existingScript && !existingScript.src.includes(recaptchaSiteKey.value)) {
          existingScript.remove()
          const script = document.createElement('script')
          script.src = `https://www.google.com/recaptcha/enterprise.js?render=${recaptchaSiteKey.value}`
          script.async = true
          script.defer = true
          document.head.appendChild(script)
        }
      }

      // Se la modalità countdown è appena terminata, reindirizziamo alla home
      if (isInitialized.value && isCountdownMode.value && !newMode) {
        isCountdownMode.value = newMode
        window.location.href = '/'
      } else {
        isCountdownMode.value = newMode
      }
      
      countdownEndDate.value = response.data.countdownEndDate
    } catch (error) {
      console.error('[CONFIGSTORE] Error fetching store status:', error)
      isCountdownMode.value = false
    } finally {
      isInitialized.value = true
    }
  }

  // Polling automatico ogni 60 secondi per verificare se il countdown è terminato
  let statusInterval = null
  const startStatusPolling = () => {
    if (statusInterval) return
    statusInterval = setInterval(fetchStoreStatus, 60000)
  }

  const stopStatusPolling = () => {
    if (statusInterval) {
      clearInterval(statusInterval)
      statusInterval = null
    }
  }

  return {
    isCountdownMode,
    countdownEndDate,
    recaptchaSiteKey,
    freeShippingThreshold,
    isInitialized,
    fetchStoreStatus,
    startStatusPolling,
    stopStatusPolling
  }
})
